<template>
  <!-- 右侧边栏 -->
  <div class="rightSidebar" @click="rightclick()">
    <div class="rightSidebar_content">
      <input type="text" placeholder="添加任务" v-model="detailsinpt" />
    </div>
    <div class="rightSidebar_list">
      <div class="rightSidebar_center">
        <div class="center_setup">
          <!-- 分类 -->
          <div class="classification" @click.stop="classificationf">
            <img src="../../assets/img/rightsideber/familylist.png" alt="" />
            <p>{{ fackname }}</p>
          </div>
          <!-- 分类 -->
          <div class="radio_overfl" :class="dispno ? 'disbl' : ''">
            <template>
              <el-radio-group
                v-model="radio"
                class="radio_lisi"
                @change="classificationXz()"
              >
                <el-radio
                  class="radio_lisi_item"
                  :label="item.from_id"
                  v-for="(item, index) in famlitem"
                  :key="index"
                  >{{ item.name }}</el-radio
                >
              </el-radio-group>
            </template>
          </div>
          <ul>
            <li>
              <img src="../../assets/img/rightsideber/adddate.png" alt="" />
              <div class="newlybuild_time">
                <el-date-picker
                  prefix-icon=" "
                  placeholder="选择计划时间"
                  v-model="value1"
                  type="date"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </div>
            </li>
            <!-- <li>
              <img src="../../assets/img/rightsideber/adddate.png" alt="" />
              <div class="newlybuild_time">
                <el-date-picker
                  prefix-icon=" "
                  placeholder="选择计划结束时间"
                  v-model="value2"
                  type="date"
                  value-format="yyyy-MM-dd"
                >
                </el-date-picker>
              </div>
            </li> -->
            <li style="position: relative">
              <img src="../../assets/img/rightsideber/repeat.png" alt="" />
              <p v-show="repeatnumb == 1" @click.stop="repeatclick">设置重复</p>
              <p v-show="repeatnumb != 1" @click.stop="repeatclick">
                {{ repeatitem[repeatnumb - 1] }}
              </p>
              <div class="radio_overfl" :class="cfdispno ? 'disbl' : ''">
                <template>
                  <el-radio-group v-model="repeatnumb" class="radio_lisi">
                    <el-radio
                      class="radio_lisi_item"
                      :label="index + 1"
                      v-for="(item, index) in repeatitem"
                      :key="index"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </template>
                <div
                  class="deletesp"
                  @click="repeatnumb = 1"
                  v-show="repeatnumb != 1"
                >
                  <img src="../../assets/img/home/center/deleter.png" alt="" />
                  <span @click="dleetcf()">删除重复</span>
                </div>
              </div>
            </li>
            <li style="position: relative">
              <img src="../../assets/img/rightsideber/setquadrant.png" alt="" />
              <p v-show="fournumb == 4" @click.stop="fourclick">设置象限</p>
              <p v-show="fournumb != 4" @click.stop="fourclick">
                {{ fourtitem[fournumb - 1] }}
              </p>
              <div class="radio_overfl" :class="fourdisp ? 'disbl' : ''">
                <template>
                  <el-radio-group v-model="fournumb" class="radio_lisi">
                    <el-radio
                      class="radio_lisi_item"
                      :label="index + 1"
                      v-for="(item, index) in fourtitem"
                      :key="index"
                      >{{ item }}</el-radio
                    >
                  </el-radio-group>
                </template>
                <div
                  class="deletesp"
                  @click="fournumb = 4"
                  v-show="fournumb != 4"
                >
                  <img src="../../assets/img/home/center/deleter.png" alt="" />
                  <p @click="deletxx()">删除象限</p>
                </div>
              </div>
            </li>
          </ul>
        </div>
        <div class="add_notes">
          <img src="../../assets/img/rightsideber/addnotes.png" alt="" />
          <textarea
            placeholder="添加备注"
            class="newlybuild_describe"
            v-model="textareaipt"
          ></textarea>
        </div>
      </div>
      <div class="rightSidebar_bottom">
        <el-button type="primary" plain style="width: 100%" @click="reletodo">{{
          btnText
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import bus from "./../../util/bus";
export default {
  data() {
    return {
      textareaipt: "",
      radio: 0,
      dispno: false,
      famlitem: [],
      detailsdata: "",
      detailsinpt: "",
      fackname: "",
      task_status: "",
      // value1: "",
      //控制重复按钮
      cfdispno: false,
      repeatnumb: 1,
      repeatitem: ["无", "每天", "每周工作日", "每周", "每月", "每年"],
      //控制选择四象限按钮
      fourdisp: false,
      fournumb: 4,
      fourtitem: ["重要紧急", "重要不紧急", "不重要紧急", "不重要不紧急"],
      uptiem: "",
      btnText: "发布",
      todoId: "",
    };
  },
  props: {
    options: Object, // 表格分页数据
    value1: {},
    value2: {},
  },
  watch: {
    options(e) {
      console.log(e, "监听的擦拭农户");
      if (JSON.stringify(e) == "{}") {
        this.rest();
        return;
      }
      this.btnText = e.btnText;
      this.todoId = e.id ? e.id : "";
      this.detailsinpt = e.task_name ? e.task_name : "";
      // 选择的分类
      this.radio = e.todo_from ? e.todo_from : 0;
      // 设置重复
      this.repeatnumb = e.task_repeat ? e.task_repeat + 1 : 1;
      // 设置象限
      this.fournumb = e.type ? e.type + 1 : 4;
      // 备注
      this.textareaipt = e.task_desc ? e.task_desc : "";
    },
  },
  created() {
    console.log(this.options, "传的参数");
    if (JSON.stringify(this.options) == "{}") {
      this.rest();
    } else {
      this.btnText = this.options.btnText;
      this.todoId = this.options.id ? this.options.id : "";
      this.detailsinpt = this.options.task_name ? this.options.task_name : "";
      // 选择的分类
      this.radio = this.options.todo_from ? this.options.todo_from : 0;
      // 设置重复
      this.repeatnumb = this.options.task_repeat
        ? this.options.task_repeat + 1
        : 1;
      // 设置象限
      this.fournumb = this.options.type ? this.options.type + 1 : 4;
      // 备注
      this.textareaipt = this.options.task_desc ? this.options.task_desc : "";
    }

    this.queryEntry();
  },
  methods: {
    todorigClick() {
      this.$emit("todorigClick");
    },
    classificationf() {
      this.dispno = !this.dispno;
    },
    //设置分类
    classificationXz() {
      for (var i = 0; i < this.famlitem.length; i++) {
        if (this.radio == this.famlitem[i].from_id)
          this.fackname = this.famlitem[i].name;
      }
    },
    queryEntry() {
      console.log(this.dispno);
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };
      this.$api
        .navnumbar("", header)
        .then((res) => {
          this.famlitem = res.data.result[1].todo_data;
          let aa = {
            from_id: 0,
            name: "未分类",
          };
          this.famlitem.unshift(aa);

          for (var i = 0; i < this.famlitem.length; i++) {
            if (this.radio == this.famlitem[i].from_id)
              this.fackname = this.famlitem[i].name;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //设置重复
    repeatclick() {
      this.cfdispno = !this.cfdispno;
      this.dispno = false;
    },
    //选择象限按钮
    fourclick() {
      this.fourdisp = !this.fourdisp;
      this.cfdispno = false;
      this.dispno = false;
    },
    //删除重复
    dleetcf() {
      this.repeatnumb = 1;
    },

    //删除象限
    deletxx() {
      this.fournumb = 4;
    },

    // 监听全页面的点击事件
    rightclick() {
      this.dispno = false;
      this.cfdispno = false;
      this.fourdisp = false;
    },
    reletodo() {
      console.log("发布");
      if (!this.detailsinpt) {
        this.$message.warning("请填写任务");
        return;
      }
      if (!this.value1) {
        this.$message.warning("请选择计划时间");
        return;
      }
      // if (!this.value2) {
      //   this.$message.warning("请选择计划结束时间");
      //   return;
      // }
      if (this.radio == 0) {
        this.radio = "";
      }
      let data = {
        //内容
        task_name: this.detailsinpt,
        //象限
        type: this.fournumb - 1,
        //重复
        task_repeat: this.repeatnumb - 1,
        //时间
        task_time: this.value1,
        // task_endtime: this.value2,
        //备注
        task_desc: this.textareaipt,
        todo_from: this.radio,
      };
      if (this.btnText == "发布") {
        this.addtodo(data);
      } else {
        this.modifyTodo(this.todoId, data);
      }
    },

    addtodo(data) {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      this.$api
        .releasetodo(data, header)
        .then((res) => {
          console.log(res, "发布清单");
          bus.$emit("refreshLeft");
          //month重新获取数据
          bus.$emit("release");
          this.$emit("weekapi");
          this.rest();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    modifyTodo(id, data) {
      let header = {
        Authorization: "Bearer " + localStorage.getItem("token"),
      };

      this.$api
        .modifytodo(id, data, header)
        .then((res) => {
          console.log(res, "修改清单");
          bus.$emit("release");
          this.$emit("weekapi");
          this.rest();
        })
        .catch((err) => {
          console.log(err);
        });
    },

    rest() {
      this.detailsinpt = "";
      this.fournumb = 4;
      this.repeatnumb = 1;
      this.textareaipt = "";
    },
  },
};
</script>

<style lang="scss">
.rightSidebar {
  width: 100%;
  height: 100%;
  background-color: #fff;
  padding-left: 4px;
  display: flex;
  flex-direction: column;

  .rightSidebar_list {
    font-size: 15px;
    color: #666;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    .rightSidebar_center {
      width: 100%;
      flex: 1;
      background-color: #f2f4f8;
      padding: 4%;
      .center_setup {
        position: relative;
        background-color: #fff;
        padding: 0 18px;
        border-radius: 8px;
        img {
          width: 15px;
          height: 15px;
          margin-right: 18px;
        }

        .classification {
          padding: 18px 0 10px 0;
          display: flex;
          align-items: center;
        }
        .disbl {
          display: block !important;
        }
        .deletesp {
          display: flex;
          width: 100%;
          align-items: center;
          padding-left: 30px;
          color: #dc282b;
          img {
            width: 15px;
            height: 15px;
            margin: 0 8px 0 0;
          }
        }
        .radio_overfl {
          display: none;
          position: absolute;
          top: 40px;
          left: 50px;
          width: 180px;
          height: auto;
          max-height: 280px;
          overflow-y: auto;
          background-color: #fff;
          z-index: 50;
          box-shadow: 0px 4px 32px 3px rgba(0, 0, 0, 0.19);
          .radio_lisi {
            display: flex;
            flex-direction: column;
            .el-radio {
              padding: 0;
              margin-left: 30px;
            }
            .radio_lisi_item {
              text-align: left;
              line-height: 35px;
              font-size: 14px;
            }
          }
        }

        ul {
          li {
            display: flex;
            align-items: center;
            font-size: 15px;
            line-height: 46px;
            p {
              display: inline-block;
              height: 100%;
              width: 100%;
              border-bottom: 1px solid #dedede;
            }
          }
          li:last-child p {
            border: none;
          }
          .newlybuild_time {
            width: 100%;
            .el-input {
              width: 100%;
            }
            .el-input__inner {
              border: 0;
              padding-left: 0;
              border-bottom: 1px solid #dedede;
              box-sizing: border-box;
            }
          }
        }
      }
      .add_notes {
        display: flex;
        background-color: #fff;
        margin: 20px 0;
        height: 30%;
        padding: 18px;
        border-radius: 8px;
        img {
          width: 15px;
          height: 18px;
        }
        .newlybuild_describe {
          width: 100%;
          height: 100%;
          padding-left: 5px;
          resize: none;
          outline: none;
          border-style: none;
          font-size: 15px;
          font-family: SourceHanSansSC-Regular;
        }
      }
    }
    .rightSidebar_bottom {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 3%;
      width: 100%;
      height: 50px;
      background-color: #fff;
      img {
        width: 10px;
        height: 18px;
      }
      :nth-child(3) {
        width: 18px;
        height: 18px;
      }
    }
  }
}
.rightSidebar_content {
  padding: 51px 4% 34px 4%;
  width: 100%;
  display: flex;
  input {
    width: 100%;
    height: 50px;
    border: none;
    border-radius: 3px;
    background-color: #f2f4f8;
    padding: 0 10px;
  }
}
</style>